import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function CloseSmall(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.657.282a.75.75 0 111.06 1.06L11.062 10l8.657 8.657a.75.75 0 01-1.06 1.06L10 11.062l-8.657 8.657a.75.75 0 01-1.06-1.06L8.938 10 .282 1.343a.75.75 0 011.06-1.06L10 8.938 18.657.282z",
    clipRule: "evenodd"
  }));
}

export default CloseSmall;
//# sourceMappingURL=CloseSmall.js.map